// An approved invoice that was issued in error is VOIDED, never deleted: the
// snapshot stays for audit with status "VOID", and every report that reads
// approved_invoice_snapshots skips it through this one check.
export function isVoided(snapshot) {
  return snapshot?.status === "VOID";
}

export function activeSnapshotDocs(result) {
  return result.docs.filter((d) => !isVoided(d.data()));
}
